import { useTypeFilterModel } from './type-filter.model'
import { TypeFilterView } from './type-filter.view'

export const TypeFilter = () => {
  const typeFilterModel = useTypeFilterModel()
  return <TypeFilterView {...typeFilterModel} />
}
